$('.cart-icon-wrap').click(function (e) {
  e.preventDefault();
  $('body').toggleClass('cartShown');
});
$('.cart-heading-cta').click(function (e) {
  e.preventDefault();
  $('body').removeClass('cartShown');
});
$('.cart-backdrop').click(function () {
  $('body').removeClass('cartShown');
});

$('.single-product-plan__freq').click(function (e) {
  e.stopPropagation();
  $(this).toggleClass('custom-dropdown_show');
});
$('.custom-drop-open').click(function (e) {
  e.stopPropagation();
  $(this).toggleClass('custom-dropdown_show');
});

$(document).click(function () {
  $('.single-product-plan__freq').removeClass('custom-dropdown_show');
  $('.custom-drop-open').removeClass('custom-dropdown_show');
});

var selected_variant = $('input[name=id]').val();
$('.product-option-select input').change(function () {
  let options = [];

  $('.product-option-select').each(function (e) {
    if ($(this).find('input').is(':checked')) {
      options.push($(this).find('input:checked').val());
    }
  });
  let string = options.toString();

  let variant = $('.single-product__variant').find(
    "[data-options='" + string + "']"
  );
  $(variant).prop('checked', true);
  if (variant.data('availability') == 'available') {
    $('.single-product__form').addClass('product-available');
    $('.single-product__form').removeClass('product-not-available');
  } else {
    $('.single-product__form').removeClass('product-available');
    $('.single-product__form').addClass('product-not-available');
  }

  selected_variant = $(variant).val();

  $('.da_variant').val(selected_variant);
  var var_price = $(variant).attr('real-price');
  var var_discount_price = $(variant).attr('discount-price');
  $('.single-product-plan__plan-one-time .single-product-plan__price').text(
    var_price
  );
  $('.single-product-plan__plan-subscription .single-product-plan__price').text(
    var_discount_price
  );

  if (selected_variant == '43159172546784') {
    $('.single-product-plan__plan-subscription').addClass('sub_disabled');
  } else {
    $('.single-product-plan__plan-subscription').removeClass('sub_disabled');
  }
});

var max_height = 0;
$('.usp-tab-content-item').each(function () {
  var content_height = $(this).outerHeight();
  if (content_height > max_height) {
    max_height = content_height;
  }
});
$('.usp-tabs-content').outerHeight(max_height);

if (selected_variant == '43159172546784') {
  $('.single-product-plan__plan-subscription').addClass('sub_disabled');
}

var plan_selected = $('.single-product-plan__plan input:checked').attr('id');
$('.single-product-plan__plan input').change(function () {
  plan_selected = $('.single-product-plan__plan input:checked').attr('id');
  $('.single-product-plan__plan').removeClass(
    'single-product-plan__plan_selected'
  );
  $('.single-product-plan__plan input:checked')
    .parent()
    .addClass('single-product-plan__plan_selected');
  let price = $(this).parent().find('.single-product-plan__price').html();
  if (price.length > 0) {
    $('.regular-price').html(price);
  }
  if (plan_selected == 'subscribe') {
    $('.single-product-plan__freq-wrapper').slideDown(200);
  } else {
    $('.single-product-plan__freq-wrapper').slideUp(200);
  }
});

var selected_plan_id = $(
  '.custom-dropdown__list-wrap .custom-dropdown__list:first-child'
).attr('data-plan');

$('.custom-dropdown__list').click(function () {
  var selected_plan = $(this).text();
  selected_plan_id = $(this).attr('data-plan');
  $(this)
    .parent()
    .parent()
    .find('.custom-dropdown-stat span')
    .text(selected_plan);
  var old_id = $(this).attr('data-old-plan');

  if (selected_plan_id != old_id) {
    $(this)
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .find('.sub-update .the-freq')
      .val(selected_plan_id)
      .trigger('change');
    $(this)
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .find('.sub-update')
      .addClass('make-active');
  }
});

//------------ Ajax cart
$('.single-atc-btn').on('click', function (e) {
  e.preventDefault();
  var $button = $(this);
  $button.addClass('loading');
  $button.text('Adding...');

  if (plan_selected == 'one_time') {
    console.log('selected_variant', selected_variant);
    // Get quantity from the quantity selector
    var quantity = parseInt($('#quantity-input').val()) || 1;

    var items = [{ id: selected_variant, quantity: quantity }];
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: { items },
      success: function (data) {
        $button.text('Added to bag');
        get_cart_details();

        // Reset button after 2 seconds
        setTimeout(function () {
          $button.removeClass('loading');
          $button.text('Add to bag');
        }, 2000);
      },
      error: function () {
        $button.removeClass('loading');
        $button.text('Add to bag');
      },
    });
  } else {
    // Get quantity from the quantity selector
    var quantity = parseInt($('#quantity-input').val()) || 1;

    var items = [
      {
        id: selected_variant,
        quantity: quantity,
        selling_plan: selected_plan_id,
      },
    ];
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: { items },
      success: function (data) {
        $button.text('Added to bag');
        get_cart_details();

        // Reset button after 2 seconds
        setTimeout(function () {
          $button.removeClass('loading');
          $button.text('Add to bag');
        }, 2000);
      },
      error: function () {
        $button.removeClass('loading');
        $button.text('Add to bag');
      },
    });
  }
});

//------------ Similar Product Add to Cart
$('.similar-product__add-to-cart').on('click', function (e) {
  e.preventDefault();
  var $button = $(this);
  var productId = $button.data('product-id');
  var variantId = $button.data('variant-id');

  // Add loading state
  $button.addClass('loading');
  $button.text('Adding...');

  var items = [{ id: variantId, quantity: 1 }];

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: { items },
    success: function (data) {
      // Success state
      $button.text('Added to bag');

      // Open cart drawer
      get_cart_details();

      // Reset button after 2 seconds
      setTimeout(function () {
        $button.removeClass('loading');
        $button.text('Add to bag');
      }, 2000);
    },
    error: function () {
      // Error state - reset button
      $button.removeClass('loading');
      $button.text('Add to bag');
    },
  });
});

// ----------------- Get cart details -------------\\
function get_cart_details() {
  $.getJSON('/cart.js', function (cart) {
    // The cart data
    var drawer_item_html = '';
    var cart_items = cart.items;
    var total_items = cart.item_count;
    product_total_price = cart.total_price;
    $('body').addClass('cartShown');
    $('.cart').removeClass('cart-empty');
    $('.cart-total-amount').text(
      my_Shop_Currency +
        (product_total_price * 0.01)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    );
    console.log(cart_items);

    $('.add-to-cart-btn').removeClass('loading');
    $('.shopify-product-form').removeClass('loading');
    $('.single-atc-btn').removeClass('loading');
    $('.cart-icon-wrap a span').text(total_items);

    for (var i = 0; i <= cart_items.length; i++) {
      var product_image = cart_items[i].image;
      var product_name = cart_items[i].product_title;
      var product_id = cart_items[i].id;
      var product_variant = cart_items[i].variant_title;
      var product_quantity = cart_items[i].quantity;
      var product_variant_id = cart_items[i].variant_id;
      var product_url = cart_items[i].url;
      var product_key = cart_items[i].key;
      var da_product_total_price = cart_items[i].final_line_price;
      var selling_plan = cart_items[i].selling_plan_allocation;
      $('.' + product_id).addClass('upsell__added');
      $('.your-cart-inner').removeClass('no-item');

      // ------------- Add HTML item here -------------//
      drawer_item_html += ' <div class="product-cart-item">';
      drawer_item_html +=
        '<a href="' + product_url + '" class="cart-item-thumb">';
      drawer_item_html += ' <figure>';
      drawer_item_html += ' <img src="' + product_image + '">';
      drawer_item_html += ' </figure>';
      drawer_item_html += ' </a>';
      drawer_item_html += '<div class="cart-item-title">';
      drawer_item_html += '<div class="cart-item-content">';
      drawer_item_html += '  <h6>' + product_name + '</h6>';
      if (selling_plan != undefined) {
        var da_plan = selling_plan.selling_plan.name;
        drawer_item_html +=
          '<span>' +
          product_variant +
          '<span class="plan">' +
          da_plan +
          '</span></span> ';
      } else {
        drawer_item_html += '<span>' + product_variant + '</span> ';
      }

      drawer_item_html += '</div>';
      drawer_item_html += '<div class="cart-item-qty">';
      drawer_item_html += ' <div class="product-quantity flex">';
      drawer_item_html +=
        ' <div class="product-description-counter-counter flex">';
      drawer_item_html +=
        '<span class="button" onclick="decreaseItemCount(event, this)">-</span>';
      drawer_item_html +=
        '<input class="input-num"  name="' +
        product_variant_id +
        '" type="number" data-id="' +
        product_key +
        '"  id="updates_' +
        product_key +
        '" value="' +
        product_quantity +
        '">';
      drawer_item_html +=
        '<span class="button up-btn" onclick="increaseItemCount(event, this)">+</span>';
      drawer_item_html += '</div>';
      drawer_item_html += ' </div>';
      drawer_item_html += '<div class="total-amount flex">';
      drawer_item_html +=
        '<span data-id="' +
        product_variant_id +
        i +
        '">' +
        my_Shop_Currency +
        (da_product_total_price * 0.01).toFixed(2) +
        '</span>';
      drawer_item_html += ' </div>';
      drawer_item_html += '</div>';
      drawer_item_html += ' </div>';
      drawer_item_html += '<div class="cart-item-close">';
      drawer_item_html +=
        '<a href="#" data-id="' +
        product_variant_id +
        '" onclick="removeItem(event, this)"><img src="//cdn.shopify.com/s/files/1/0618/3056/1964/t/5/assets/close.svg" alt=""></a>';
      drawer_item_html += ' </div>';
      drawer_item_html += ' </div>';

      $('.product-cart-item-wrap').html(drawer_item_html);

      setTimeout(function () {
        $('.product-single-hero-item').removeClass('loading');
      }, 1000);
    }
  });
}

function increaseItemCount(e, el) {
  var myElement = el;
  var $input = myElement.previousElementSibling;
  var value = parseInt($input.value);
  if (value < 100) {
    value = value + 1;
  } else {
    value = 100;
  }
  $input.value = value;
  change_qty($input);
}

function decreaseItemCount(e, el) {
  var $input = el.nextElementSibling;
  var value = parseInt($input.value);
  if (value > 1) {
    value = value - 1;
  } else {
    value = 0;
    $(el).parent().parent().parent().parent().parent().remove();
  }
  $input.value = value;
  change_qty($input);
}

function change_qty($input) {
  var variant_id = $($input).attr('data-id');
  var quantity = $($input).val();
  var data = { updates: {} };
  data.updates[variant_id] = quantity;
  jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function (res) {
      product_total_price = res.items_subtotal_price;
      var pro_data = res.items;
      var price = res.total_price;
      price = price / 100;
      var tot_qty = res.item_count;
      $('.cart-icon-wrap a span').text(tot_qty);

      $('.cart-total-amount').text(
        my_Shop_Currency +
          (product_total_price * 0.01)
            .toFixed(2)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      );

      jQuery.each(pro_data, function (index, item) {
        var spe_price = item.final_line_price;
        spe_price = spe_price / 100;
        if (item.key == variant_id) {
          $('.total-amount span[data-id=' + item.id + index + ']').html(
            my_Shop_Currency +
              spe_price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          );
        }
      });

      if (tot_qty >= 1) {
      } else {
        $('.your-cart-inner').addClass('no-item');
      }
    },
  });
}

function removeItem(e, el) {
  e.preventDefault();
  var id = $(el).attr('data-id');
  // Prefer line-item key if present (more precise), else treat as variant id
  var isLineKey = /:[0-9a-f]{32}$/i.test(id) || id.indexOf(':') !== -1;

  if (isLineKey) {
    // Remove by line item key
    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: { id: id, quantity: 0 },
      dataType: 'json',
      success: handleCartUpdate,
    });
  } else {
    // Remove by variant id using updates
    var data = { updates: {} };
    data.updates[id] = 0;
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: handleCartUpdate,
    });
  }

  function handleCartUpdate(res) {
    product_total_price = res.items_subtotal_price;
    var price = res.total_price / 100;
    var tot_qty = res.item_count;
    $('.cart-icon-wrap a span').text(tot_qty);
    $('.cart-total-amount').text(
      my_Shop_Currency + price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    );
    if (tot_qty >= 1) {
      $('.cart-empty').removeClass('cart__blank');
    } else {
      $('.your-cart-inner').addClass('no-item');
    }
    // Remove the DOM node safely
    $(el).closest('.product-cart-item').remove();
  }
}

$('.btn-update').click(function () {
  var line_index = $(this).attr('data-index');
  var plan_id = $(this).parent().find('.the-freq').val();
  $(this).parent().removeClass('make-active');
  jQuery.post('/cart/change.js', {
    quantity: 1,
    line: line_index,
    selling_plan: plan_id,
  });
});

$('.alt-row__texts .single-product-plan__plan').click(function (e) {
  e.preventDefault();
  $('.alt-row__texts .single-product-plan__plan').removeClass(
    'active-product-plan'
  );
  $(this).addClass('active-product-plan');
  var myProduct = $('.active-product-plan a').attr('href');
  $(this).parent().parent().find('.alt-row__btn').attr('href', myProduct);
});

// Accordion functionality moved to product.liquid for better performance and accessibility

// Product Gallery Slider Class
class ProductGallerySlider {
  constructor() {
    this.gallery = document.getElementById('product-gallery');
    this.thumbnails = document.getElementById('product-thumbnails');

    if (!this.gallery || !this.thumbnails) return;

    this.container = this.gallery.querySelector(
      '.single-product__main-image-container'
    );
    this.slides = this.gallery.querySelectorAll(
      '.single-product__main-image-item'
    );
    this.thumbButtons = this.thumbnails.querySelectorAll(
      '.single-product__thumb-item'
    );
    this.prevBtn = this.gallery.parentElement.querySelector(
      '.single-product__nav--prev'
    );
    this.nextBtn = this.gallery.parentElement.querySelector(
      '.single-product__nav--next'
    );

    this.currentSlide = 0;
    this.totalSlides = this.slides.length;
    this.isTransitioning = false;

    this.init();
  }

  init() {
    if (this.totalSlides <= 1) return;

    // Initialize first slide
    this.updateSlideState(-1, 0);
    this.bindEvents();
    this.updateNavigation();

    // Add focus management for accessibility
    this.gallery.setAttribute('tabindex', '0');
    this.gallery.setAttribute('role', 'region');
    this.gallery.setAttribute('aria-label', 'Product image gallery');
  }

  bindEvents() {
    // Thumbnail clicks
    this.thumbButtons.forEach((btn, index) => {
      btn.addEventListener('click', () => this.goToSlide(index));
    });

    // Navigation buttons
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        if (this.currentSlide > 0) {
          this.goToSlide(this.currentSlide - 1);
        }
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        if (this.currentSlide < this.totalSlides - 1) {
          this.goToSlide(this.currentSlide + 1);
        }
      });
    }

    // Keyboard navigation
    this.gallery.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        if (this.currentSlide > 0) {
          this.goToSlide(this.currentSlide - 1);
        }
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        if (this.currentSlide < this.totalSlides - 1) {
          this.goToSlide(this.currentSlide + 1);
        }
      }
    });

    // Touch gestures
    let startX = 0;
    let startY = 0;
    let isHorizontalSwipe = false;

    this.gallery.addEventListener(
      'touchstart',
      e => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isHorizontalSwipe = false;
      },
      { passive: true }
    );

    this.gallery.addEventListener(
      'touchmove',
      e => {
        if (!startX || !startY) return;

        const diffX = startX - e.touches[0].clientX;
        const diffY = startY - e.touches[0].clientY;

        if (Math.abs(diffX) > Math.abs(diffY)) {
          isHorizontalSwipe = true;
        }
      },
      { passive: true }
    );

    this.gallery.addEventListener(
      'touchend',
      e => {
        if (!isHorizontalSwipe || !startX) return;

        const diffX = startX - e.changedTouches[0].clientX;
        const threshold = 50;

        if (Math.abs(diffX) > threshold) {
          if (diffX > 0 && this.currentSlide < this.totalSlides - 1) {
            this.goToSlide(this.currentSlide + 1);
          } else if (diffX < 0 && this.currentSlide > 0) {
            this.goToSlide(this.currentSlide - 1);
          }
        }

        startX = 0;
        startY = 0;
        isHorizontalSwipe = false;
      },
      { passive: true }
    );
  }

  // Helper method to update slide state consistently
  updateSlideState(previousIndex, currentIndex) {
    // Simple fade transition - just toggle active class
    this.slides.forEach((slide, i) => {
      slide.classList.remove('active');
      if (i === currentIndex) {
        slide.classList.add('active');
      }
    });

    // Update thumbnail classes and aria attributes
    if (previousIndex >= 0) {
      this.thumbButtons[previousIndex].classList.remove('active');
      this.thumbButtons[previousIndex].setAttribute('aria-current', 'false');
      this.slides[previousIndex].setAttribute('aria-current', 'false');
    }

    this.thumbButtons[currentIndex].classList.add('active');
    this.thumbButtons[currentIndex].setAttribute('aria-current', 'true');
    this.slides[currentIndex].setAttribute('aria-current', 'true');

    // Update thumbnail filters to ensure proper grayscale state
    this.updateThumbnailFilters();
  }

  // Helper method to update thumbnail filters based on animation state
  updateThumbnailFilters() {
    const singleProductSection = document.querySelector('.single-product');
    if (!singleProductSection) return;

    // Check if the section is currently in viewport and animated
    const isInViewport = singleProductSection.dataset.animated === 'true';

    // Update all thumbnail filters
    this.thumbButtons.forEach((thumb, index) => {
      const thumbImg = thumb.querySelector('img');
      if (thumbImg) {
        if (thumb.classList.contains('active')) {
          // Active thumbnail should match the viewport animation state
          thumbImg.style.filter = isInViewport
            ? 'grayscale(0%)'
            : 'grayscale(100%)';
        } else {
          // Inactive thumbnails should always be greyscale
          thumbImg.style.filter = 'grayscale(100%)';
        }
      }
    });
  }

  // Method to handle viewport state changes (called by global grayscale system)
  handleViewportStateChange(isInViewport) {
    // Update the section's animated state
    const singleProductSection = document.querySelector('.single-product');
    if (singleProductSection) {
      singleProductSection.dataset.animated = isInViewport ? 'true' : 'false';
    }

    // Update thumbnail filters to match
    this.updateThumbnailFilters();
  }

  goToSlide(index) {
    // Validate input
    if (typeof index !== 'number' || index < 0 || index >= this.totalSlides) {
      console.warn(
        `Invalid slide index: ${index}. Must be between 0 and ${this.totalSlides - 1}`
      );
      return;
    }

    if (this.isTransitioning || index === this.currentSlide) return;

    this.isTransitioning = true;
    const previousSlide = this.currentSlide;
    this.currentSlide = index;

    // Update slide state using helper method
    this.updateSlideState(previousSlide, this.currentSlide);

    // Update navigation buttons
    this.updateNavigation();

    // Let CSS control container sizing - no inline height manipulation
    if (this.container) this.container.style.height = '';

    // Reset transition flag after CSS transition completes
    setTimeout(() => {
      this.isTransitioning = false;
    }, 300);
  }

  updateNavigation() {
    if (this.prevBtn) {
      this.prevBtn.disabled = this.currentSlide === 0;
    }
    if (this.nextBtn) {
      this.nextBtn.disabled = this.currentSlide === this.totalSlides - 1;
    }
  }
}

// Efficient grayscale animation system
const GrayscaleAnimation = () => {
  if (!('IntersectionObserver' in window)) return;

  // Define selectors for images/videos that should have grayscale animation
  const grayscaleSelectors = [
    '.single-product__main-image-item img',
    '.single-product__thumb-item img',
    '.double-product__product-image',
    '.product-grid__product-image',
    '.similar-product__product-image',
    '.hero-video__video',
    '.collection-item img',
    '.product-card img',
    '.product-features__feature-image',
  ];

  // Set initial grayscale state for all elements (single query)
  const allElements = document.querySelectorAll(grayscaleSelectors.join(', '));
  allElements.forEach(element => {
    element.style.filter = 'grayscale(100%)';
  });

  // Find all sections that contain grayscale elements automatically
  const sectionsWithGrayscale = [];

  // Derive section selectors from grayscaleSelectors
  const sectionSelectors = grayscaleSelectors
    .map(selector => {
      // Extract the section part from selectors like '.single-product__main-image-item img'
      const sectionMatch = selector.match(/^\.([^_]+)/);
      return sectionMatch ? `.${sectionMatch[1]}` : null;
    })
    .filter(Boolean);

  // Get all elements and find their parent sections
  allElements.forEach(element => {
    // Find the closest section container using derived selectors
    const section = element.closest(sectionSelectors.join(', '));
    if (section && !sectionsWithGrayscale.includes(section)) {
      sectionsWithGrayscale.push(section);
      section.dataset.animated = 'false';
    }
  });

  // Create a single observer for all sections with grayscale elements
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        const section = entry.target;
        const isAnimated = section.dataset.animated === 'true';

        if (entry.isIntersecting && !isAnimated) {
          // Animate to color after delay
          setTimeout(() => {
            const sectionElements = section.querySelectorAll(
              grayscaleSelectors.join(', ')
            );
            sectionElements.forEach(element => {
              element.style.filter = 'grayscale(0%)';
            });
            section.dataset.animated = 'true';

            // Notify ProductGallerySlider for single product sections
            if (
              section.classList.contains('single-product') &&
              window.productGallerySlider
            ) {
              window.productGallerySlider.handleViewportStateChange(true);
            }
          }, 500);
        } else if (entry.isIntersecting && isAnimated) {
          // Section is in viewport and already animated - ensure color state
          const sectionElements = section.querySelectorAll(
            grayscaleSelectors.join(', ')
          );
          sectionElements.forEach(element => {
            element.style.filter = 'grayscale(0%)';
          });
        } else if (!entry.isIntersecting && isAnimated) {
          // Revert to grayscale when leaving viewport (both desktop and mobile)
          const sectionElements = section.querySelectorAll(
            grayscaleSelectors.join(', ')
          );
          sectionElements.forEach(element => {
            element.style.filter = 'grayscale(100%)';
          });
          section.dataset.animated = 'false';

          // Notify ProductGallerySlider for single product sections
          if (
            section.classList.contains('single-product') &&
            window.productGallerySlider
          ) {
            window.productGallerySlider.handleViewportStateChange(false);
          }
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -10% 0px', // Default: grayscale when leaving bottom 10%
    }
  );

  // Observe only sections that actually contain grayscale elements
  sectionsWithGrayscale.forEach(section => {
    observer.observe(section);
  });
};

// Background color animation for specific components
const BackgroundAnimation = () => {
  if (!('IntersectionObserver' in window)) return;

  // Define sections that should have background color animation
  const backgroundSections = [
    '.double-product',
    '.similar-product',
    // Add more sections as needed:
    // '.hero-section',
    // '.feature-section',
  ];

  // Create observers for each background section
  backgroundSections.forEach(selector => {
    const section = document.querySelector(selector);
    if (!section) return;

    // Set up initial styles and transition
    section.style.transition = 'background-color 0.5s ease-in-out';
    section.style.backgroundColor = 'var(--white)'; // Default color
    section.dataset.bgAnimated = 'false';

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          const isAnimated = entry.target.dataset.bgAnimated === 'true';

          if (entry.isIntersecting && !isAnimated) {
            // Change background color after delay
            setTimeout(() => {
              section.style.backgroundColor = 'var(--crusta)';
              entry.target.dataset.bgAnimated = 'true';
            }, 500);
          } else if (!entry.isIntersecting && isAnimated) {
            // Revert background color immediately
            section.style.backgroundColor = 'var(--white)';
            entry.target.dataset.bgAnimated = 'false';
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -10% 0px',
      }
    );

    observer.observe(section);
  });
};

// Hero video play/pause functionality
const heroVideoAnimation = () => {
  if (!('IntersectionObserver' in window)) return;

  const heroVideoSection = document.querySelector('.hero-video');
  if (!heroVideoSection) return;

  const video = heroVideoSection.querySelector('.hero-video__video');
  if (!video) return;

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Play video when entering viewport
          video.play().catch(error => {
            console.warn('Could not autoplay video:', error);
          });
        } else {
          // Pause video when leaving viewport
          video.pause();
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -10% 0px',
    }
  );

  observer.observe(heroVideoSection);
};

// Ticker tape animation (mobile only)
const tickerTapeAnimation = () => {
  // Only initialize on mobile devices
  if (!window.matchMedia('(max-width: 768px)').matches) {
    return null; // No animation on desktop
  }

  if (!('IntersectionObserver' in window)) return null;

  const tickerTapeSection = document.querySelector('.ticker-tape');
  if (!tickerTapeSection) return null;

  let isAnimated = false;
  let timeoutId = null;

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !isAnimated) {
          // Add visible class after delay
          timeoutId = setTimeout(() => {
            tickerTapeSection.classList.add('ticker-tape--visible');
            isAnimated = true;
          }, 500);
        } else if (!entry.isIntersecting && isAnimated) {
          // Remove visible class immediately
          if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = null;
          }
          tickerTapeSection.classList.remove('ticker-tape--visible');
          isAnimated = false;
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -10% 0px',
    }
  );

  observer.observe(tickerTapeSection);

  // Return cleanup function
  return {
    destroy: () => {
      observer.disconnect();
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    },
  };
};

// Quantity selector functionality
const initQuantitySelector = () => {
  const quantityInput = document.getElementById('quantity-input');
  const minusBtn = document.querySelector('.quantity-minus');
  const plusBtn = document.querySelector('.quantity-plus');
  const totalPriceElement = document.getElementById('total-price');

  if (!quantityInput || !minusBtn || !plusBtn) return;

  // Store the base price (per unit price)
  let basePrice = 0;

  // Get base price from the initial total price element
  const initializeBasePrice = () => {
    if (!totalPriceElement) return;
    const priceText = totalPriceElement.textContent;
    basePrice = parseFloat(priceText.replace(/[£$€,]/g, '')) || 0;
  };

  // Check if subscription plan is selected
  const isSubscriptionSelected = () => {
    const subscribeRadio = document.getElementById('subscribe');
    return subscribeRadio && subscribeRadio.checked;
  };

  // Update total price and button states
  const updateTotalPrice = () => {
    if (!totalPriceElement) return;
    const quantity = parseInt(quantityInput.value) || 1;
    let totalPrice = basePrice * quantity;

    // Apply 10% discount for subscription
    if (isSubscriptionSelected()) {
      totalPrice = totalPrice * 0.9; // 10% discount
    }

    // Format the price (assuming £ currency)
    const formattedPrice = `£${totalPrice.toFixed(2)}`;
    totalPriceElement.textContent = formattedPrice;

    // Update button states
    updateButtonStates(quantity);
  };

  // Update button disabled states
  const updateButtonStates = quantity => {
    const min = parseInt(quantityInput.getAttribute('min')) || 1;
    const max = parseInt(quantityInput.getAttribute('max')) || 10;

    // Disable minus button if at minimum
    minusBtn.disabled = quantity <= min;

    // Disable plus button if at maximum
    plusBtn.disabled = quantity >= max;
  };

  minusBtn.addEventListener('click', () => {
    if (minusBtn.disabled) return;

    const currentValue = parseInt(quantityInput.value);
    const minValue = parseInt(quantityInput.getAttribute('min'));
    if (currentValue > minValue) {
      quantityInput.value = currentValue - 1;
      updateTotalPrice();
    }
  });

  plusBtn.addEventListener('click', () => {
    if (plusBtn.disabled) return;

    const currentValue = parseInt(quantityInput.value);
    const maxValue = parseInt(quantityInput.getAttribute('max'));
    if (currentValue < maxValue) {
      quantityInput.value = currentValue + 1;
      updateTotalPrice();
    }
  });

  // Validate input on change and update total
  quantityInput.addEventListener('change', () => {
    const value = parseInt(quantityInput.value);
    const min = parseInt(quantityInput.getAttribute('min'));
    const max = parseInt(quantityInput.getAttribute('max'));

    if (value < min) {
      quantityInput.value = min;
    } else if (value > max) {
      quantityInput.value = max;
    }

    updateTotalPrice();
  });

  // Set up event listeners for plan selection
  const oneTimeRadio = document.getElementById('one_time');
  const subscribeRadio = document.getElementById('subscribe');

  if (oneTimeRadio) {
    oneTimeRadio.addEventListener('change', updateTotalPrice);
  }

  if (subscribeRadio) {
    subscribeRadio.addEventListener('change', updateTotalPrice);
  }

  // Initialize base price and total price on load
  initializeBasePrice();
  updateTotalPrice();
};

// Modern accordion functionality
class ProductAccordion {
  constructor() {
    this.accordion = document.querySelector('.single-product__accordion');
    if (!this.accordion) return;

    this.items = this.accordion.querySelectorAll(
      '.single-product__accordion-item'
    );
    this.init();
  }

  init() {
    this.items.forEach(item => {
      const trigger = item.querySelector('.single-product__accordion-title');
      const content = item.querySelector('.single-product__accordion-text');

      if (!trigger || !content) return;

      // Click handler
      trigger.addEventListener('click', () => this.toggleItem(item));

      // Keyboard handler
      trigger.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggleItem(item);
        }
      });
    });
  }

  toggleItem(item) {
    const trigger = item.querySelector('.single-product__accordion-title');
    const content = item.querySelector('.single-product__accordion-text');
    const isOpen = item.classList.contains(
      'single-product__accordion-item_active'
    );

    if (isOpen) {
      this.closeItem(item);
    } else {
      this.openItem(item);
    }
  }

  openItem(item) {
    const trigger = item.querySelector('.single-product__accordion-title');
    const content = item.querySelector('.single-product__accordion-text');

    // Close other items first (accordion behavior)
    this.items.forEach(otherItem => {
      if (otherItem !== item) {
        this.closeItem(otherItem);
      }
    });

    // Open this item - CSS handles the animation
    item.classList.add('single-product__accordion-item_active');
    trigger.setAttribute('aria-expanded', 'true');
  }

  closeItem(item) {
    const trigger = item.querySelector('.single-product__accordion-title');
    const content = item.querySelector('.single-product__accordion-text');

    // Close this item - CSS handles the animation
    item.classList.remove('single-product__accordion-item_active');
    trigger.setAttribute('aria-expanded', 'false');
  }
}

// Product Reviews Carousel
class ProductReviewsCarousel {
  constructor() {
    this.carousel = document.querySelector('.product-reviews__carousel');
    if (!this.carousel) {
      console.log('Product Reviews Carousel: No carousel found');
      return;
    }

    this.items = this.carousel.querySelectorAll('.product-reviews__item');
    this.progressBar = this.carousel.querySelector(
      '.product-reviews__progress-fill'
    );
    this.currentIndex = 0;
    this.totalItems = this.items.length;
    this.autoPlayInterval = null; // deprecated: previously used
    this.progressInterval = null; // deprecated: replaced by rAF
    this.autoPlayDelay = 8000; // 8 seconds
    this.currentProgress = 0;
    this.progressRafId = null;
    this.progressStartTime = 0;
    this.pausedProgressPercent = 0;
    this.isPaused = false;
    this.isAutoPlaying = false;
    this.isHovered = false;
    this.isAdvancing = false;

    // Always init to handle both cases; guard logic below will short-circuit behaviors
    this.init();
  }

  init() {
    // If only one item, show it and skip timers/interactions
    if (this.totalItems <= 1) {
      if (this.items[0]) {
        this.items[0].classList.add('product-reviews__item--active');
      }
      this.setFixedContainerHeight();
      return;
    }
    this.bindEvents();
    this.setFixedContainerHeight(); // Set fixed height based on tallest review
    this.startAutoPlay();
  }

  bindEvents() {
    // Click/tap to cycle through slides
    this.carousel.addEventListener('click', () => this.manualNextSlide());

    // Only add hover events on desktop (not mobile)
    if (!this.isMobile()) {
      // Pause auto-play on hover (but keep progress bar visible)
      this.carousel.addEventListener('mouseenter', () => {
        this.isHovered = true;
        this.pauseAutoPlay();
      });
      this.carousel.addEventListener('mouseleave', () => {
        this.isHovered = false;
        this.resumeAutoPlay();
      });
    }

    // Pause auto-play when page is not visible
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.pauseAutoPlay();
      } else {
        this.resumeAutoPlay();
      }
    });
  }

  goToSlide(index, startProgress = true) {
    if (index === this.currentIndex) return;

    // Validate index
    if (index < 0 || index >= this.totalItems) {
      console.log('Product Reviews Carousel: Invalid index', index);
      return;
    }

    // Stop current progress animation
    this.stopProgressAnimation();

    // Remove active class (with safety check)
    if (this.items[this.currentIndex]) {
      this.items[this.currentIndex].classList.remove(
        'product-reviews__item--active'
      );
    }

    // Update current index
    this.currentIndex = index;

    // Add active class (with safety check)
    if (this.items[this.currentIndex]) {
      this.items[this.currentIndex].classList.add(
        'product-reviews__item--active'
      );
    }

    // Start progress animation for new slide only if requested
    if (startProgress) {
      this.startProgressAnimation();
    }
  }

  setFixedContainerHeight() {
    // Create temporary clones to measure heights without affecting the carousel
    let maxHeight = 0;

    this.items.forEach((item, index) => {
      // Create a clone of the item
      const clone = item.cloneNode(true);
      clone.style.position = 'static';
      clone.style.opacity = '1';
      clone.style.visibility = 'hidden';
      clone.style.pointerEvents = 'none';
      clone.style.width = '100%';
      clone.style.padding = 'var(--space-800) 0'; // Ensure proper padding for measurement

      // Add clone to container temporarily
      this.carousel
        .querySelector('.product-reviews__carousel-container')
        .appendChild(clone);

      // Measure height
      const height = clone.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }

      // Remove clone
      this.carousel
        .querySelector('.product-reviews__carousel-container')
        .removeChild(clone);
    });

    // Set the container to the maximum height (with fallback)
    const finalHeight = maxHeight > 0 ? maxHeight : 200; // Fallback to 200px if no height calculated
    this.carousel.querySelector(
      '.product-reviews__carousel-container'
    ).style.height = finalHeight + 'px';
  }

  nextSlide() {
    const nextIndex = (this.currentIndex + 1) % this.totalItems;
    this.goToSlide(nextIndex);
  }

  manualNextSlide() {
    // Advance to next slide while respecting hover state
    this.stopProgressAnimation();
    const nextIndex = (this.currentIndex + 1) % this.totalItems;
    this.goToSlide(nextIndex, false);
    // Restart progress only if not hovered
    if (!this.isHovered) {
      this.startProgressAnimation();
    }
  }

  startAutoPlay() {
    // Drive solely by progress bar
    this.stopProgressAnimation();
    this.startProgressAnimation();
    this.isAutoPlaying = true;
  }

  stopAutoPlay() {
    this.stopProgressAnimation();
    this.isAutoPlaying = false;
  }

  pauseAutoPlay() {
    this.isPaused = true;
    // Cancel any scheduled animation frame
    if (this.progressRafId) {
      cancelAnimationFrame(this.progressRafId);
      this.progressRafId = null;
    }
  }

  resumeAutoPlay() {
    this.isPaused = false;
    // Only resume if we were auto-playing before the pause
    if (this.isAutoPlaying) {
      this.resumeProgressAnimation();
    }
  }

  startProgressAnimation() {
    this.stopProgressAnimation();
    if (!this.progressBar) return;

    // Reset progress for new slide
    this.currentProgress = 0;
    this.pausedProgressPercent = 0;
    this.progressBar.style.width = '0%';
    this.progressStartTime = performance.now();

    const tick = now => {
      // If paused or hovered, do not continue the animation loop
      if (this.isPaused || this.isHovered) {
        this.progressRafId = null;
        return;
      }
      const elapsed = now - this.progressStartTime;
      const progress = Math.min(100, (elapsed / this.autoPlayDelay) * 100);
      this.currentProgress = progress;
      this.pausedProgressPercent = progress;
      this.progressBar.style.width = progress + '%';

      if (progress >= 100) {
        // Advance to the next slide and start a new cycle
        if (!this.isPaused && !this.isHovered && !this.isAdvancing) {
          this.isAdvancing = true;
          const nextIndex = (this.currentIndex + 1) % this.totalItems;
          this.goToSlide(nextIndex, false);
          this.isAdvancing = false;
          // Start next cycle
          this.progressStartTime = performance.now();
          this.currentProgress = 0;
          this.pausedProgressPercent = 0;
          this.progressBar.style.width = '0%';
          this.progressRafId = requestAnimationFrame(tick);
        }
        return;
      }
      this.progressRafId = requestAnimationFrame(tick);
    };
    this.progressRafId = requestAnimationFrame(tick);
  }

  resumeProgressAnimation() {
    if (!this.progressBar) return;

    // Resume from current progress percent using time-based calculation
    const clampedPercent = Math.max(
      0,
      Math.min(100, this.pausedProgressPercent || this.currentProgress || 0)
    );
    const elapsedMs = (clampedPercent / 100) * this.autoPlayDelay;
    this.progressStartTime = performance.now() - elapsedMs;

    const tick = now => {
      if (this.isPaused || this.isHovered) {
        this.progressRafId = null;
        return;
      }
      const elapsed = now - this.progressStartTime;
      const progress = Math.min(100, (elapsed / this.autoPlayDelay) * 100);
      this.currentProgress = progress;
      this.pausedProgressPercent = progress;
      this.progressBar.style.width = progress + '%';

      if (progress >= 100) {
        if (!this.isPaused && !this.isHovered && !this.isAdvancing) {
          this.isAdvancing = true;
          const nextIndex = (this.currentIndex + 1) % this.totalItems;
          this.goToSlide(nextIndex, false);
          this.isAdvancing = false;
          this.progressStartTime = performance.now();
          this.currentProgress = 0;
          this.pausedProgressPercent = 0;
          this.progressBar.style.width = '0%';
          this.progressRafId = requestAnimationFrame(tick);
        }
        return;
      }
      this.progressRafId = requestAnimationFrame(tick);
    };
    this.progressRafId = requestAnimationFrame(tick);
  }

  stopProgressAnimation() {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
      this.progressInterval = null;
    }
    if (this.progressRafId) {
      cancelAnimationFrame(this.progressRafId);
      this.progressRafId = null;
    }
    // Reset progress bar only when not paused
    if (this.progressBar && !this.isPaused) {
      this.progressBar.style.width = '0%';
      this.currentProgress = 0;
      this.pausedProgressPercent = 0;
    }
  }

  isMobile() {
    return (
      window.matchMedia('(max-width: 768px)').matches ||
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0
    );
  }
}

// Initialize product page functionality when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Initialize product gallery slider and make it globally available
  window.productGallerySlider = new ProductGallerySlider();

  // Initialize the greyscale to color animation

  // Initialize quantity selector
  initQuantitySelector();

  // Initialize accordion
  new ProductAccordion();

  // Initialize reviews carousel with a small delay to ensure DOM is fully rendered
  setTimeout(() => {
    new ProductReviewsCarousel();
  }, 100);

  // Additional height calculation to prevent shift
  if (slider && slider.container) {
    // On mobile, ensure inline height is cleared so CSS can size naturally
    if (window.matchMedia('(max-width: 768px)').matches) {
      slider.container.style.height = '';
    }
  }
});

// Initialize grayscale animations for all sections
document.addEventListener('DOMContentLoaded', () => {
  // Initialize universal grayscale animation for all images/videos
  GrayscaleAnimation();

  // Initialize background color animations for specific components
  BackgroundAnimation();

  // Initialize hero video play/pause functionality
  if (document.querySelector('.hero-video')) {
    heroVideoAnimation();
  }

  // Initialize ticker tape animation (mobile only)
  if (document.querySelector('.ticker-tape')) {
    tickerTapeAnimationInstance = tickerTapeAnimation();
  }
});

// Handle ticker tape animation on resize (desktop to mobile)
let tickerTapeAnimationInstance = null;
window.addEventListener('resize', () => {
  const tickerTape = document.querySelector('.ticker-tape');
  if (!tickerTape) return;

  const isMobile = window.matchMedia('(max-width: 768px)').matches;

  if (isMobile && !tickerTapeAnimationInstance) {
    // Switch to mobile: initialize animation
    tickerTapeAnimationInstance = tickerTapeAnimation();
  } else if (!isMobile && tickerTapeAnimationInstance) {
    // Switch to desktop: destroy animation
    tickerTapeAnimationInstance.destroy();
    tickerTapeAnimationInstance = null;
  }
});
